import { Store } from 'utils';

class CounterStore extends Store {

	getInitialState() {
		return {
			count: 0,
			inProgress: false
		}
	}

	onChangeInProgress(state) {
		state.inProgress = true;
	}

	onAdd(state, data) {
		state.count = state.count + data.value;
		state.inProgress = false;
	}

}

const store = new CounterStore();
export default store;


// WEBPACK FOOTER //
// ./src/modules/model/CounterStore.js